export default function ArtisticMilestones() {
  const milestones = [{
    number: "12+",
    label: "Years Local Expertise"
  }, {
    number: "200+",
    label: "LOCAL VENDORS"
  }, {
    number: "10+",
    label: "LANGUAGES"
  }, {
    number: "100%",
    label: "Tailored Logistics"
  }];
  return;
}